export default __webpack_public_path__ + "31f420d22440cfbd3a701f03b4e34ccd.woff";